import React from 'react'
import { useNavigate } from 'react-router-dom';
import TableData from "../Partials/TableData3";

export const Userpermission = () => {
  const path = "Permission"
  const navigate = useNavigate()

  const editClick = async (item) => {
    navigate(`../userrole/${item._id}`);
  }

  return (
    <React.Fragment>
      <div className="add-user-container">
        <div className='headingdiv'>
          <span className="componet-title">Role List</span>
          <div>
            <button onClick={(() => navigate(-1))}>Back</button>
         </div>
        </div>
        <div className="option-btn">
          <button onClick={() => { navigate("../userrole") }}>Add New Role</button>
        </div>
        <TableData path={path}  editClick={editClick}/>
      </div>
    </React.Fragment>
  );
}
